import gql from 'graphql-tag';

import formTemplateFragment from '~/shared/graphql-queries/form-templates/form-template-fragment';

export default gql`
  query findByIdFormTemplateQuery($_id: MongoID!) {
    findByIdFormTemplateQuery(_id: $_id) {
      ...FormTemplateFragment
    }
  }
  ${formTemplateFragment}
`;
